module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border heading-cart"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("New Layouts")]), _vm._v(" "), _c('el-dialog', {
    staticClass: "element-promt",
    attrs: {
      "title": "Meta Tags",
      "visible": _vm.dialogVisible,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 10
    },
    model: {
      value: (_vm.metaCopy),
      callback: function($$v) {
        _vm.metaCopy = $$v
      },
      expression: "metaCopy"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.metaCopy),
      expression: "metaCopy",
      arg: "copy"
    }],
    staticClass: "el-button el-button--info pull-right",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-copy fa-w-14",
    staticStyle: {
      "font-size": "48px"
    },
    attrs: {
      "aria-hidden": "true",
      "width": "16px",
      "height": "16px",
      "data-prefix": "fal",
      "data-icon": "copy",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z"
    }
  })]), _vm._v("  Copy Meta\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%",
      "border-spacing": "0"
    },
    attrs: {
      "data": _vm.existingLayouts,
      "height": "300",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Layout name",
      "width": "420",
      "prop": "layout_name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(props.row.layout_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-dropdown', {
          staticClass: "see-usage",
          attrs: {
            "trigger": "click"
          },
          on: {
            "command": _vm.OpenLayoutUsage
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_vm._v("\n                                    See usage in bucket"), _c('i', {
          staticClass: "el-icon-arrow-down el-icon--right"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, _vm._l((_vm.domain_details.buckets), function(bucket) {
          return _c('el-dropdown-item', {
            key: bucket.id,
            attrs: {
              "command": {
                alias: props.row.layout_name,
                bucket_id: bucket.id,
                id: props.row.id,
              }
            }
          }, [_c('span', [_vm._v(_vm._s(bucket.name))])])
        }), 1)], 1), _vm._v(" "), _c('br')]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Layout type",
      "width": "200",
      "prop": "type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', [_vm._v(_vm._s(props.row.type))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Active"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.is_active) ? _c('div', [_c('svg', {
          staticClass: "svg-inline--fa fa-check-circle fa-w-16 fa-2x",
          attrs: {
            "data-v-7a40f996": "",
            "aria-hidden": "true",
            "height": "20px",
            "width": "20px",
            "data-prefix": "far",
            "data-icon": "check-circle",
            "role": "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 512 512"
          }
        }, [_c('path', {
          attrs: {
            "data-v-7a40f996": "",
            "fill": "green",
            "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
          }
        })])]) : _vm._e(), _vm._v(" "), (!props.row.is_active) ? _c('div', [_c('svg', {
          staticClass: "svg-inline--fa fa-times-circle fa-w-16 fa-2x",
          attrs: {
            "aria-hidden": "true",
            "height": "20px",
            "width": "20px",
            "data-prefix": "fal",
            "data-icon": "times-circle",
            "role": "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 512 512"
          }
        }, [_c('path', {
          attrs: {
            "fill": "red",
            "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
          }
        })])]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Edit",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('button', {
          staticClass: "el-button btn-rounded el-button--success edit",
          on: {
            "click": function($event) {
              return _vm.editLayout(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "ti-pencil"
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('form', {
    staticClass: "form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveLayout($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h5', [_vm._v("Layout name")]), _vm._v(" "), _c('el-input', {
    staticClass: "publisher-input",
    attrs: {
      "name": "selector",
      "type": "text",
      "placeholder": "layout name"
    },
    model: {
      value: (_vm.layoutForm.layoutName),
      callback: function($$v) {
        _vm.$set(_vm.layoutForm, "layoutName", $$v)
      },
      expression: "layoutForm.layoutName"
    }
  })], 1)]), _vm._v(" "), (_vm.domain_details.features && (_vm.domain_details.features['advance_layouts'] == 'enabled')) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 select-items"
  }, [_c('p', {
    staticClass: "form-label"
  }, [_vm._v("Layout Type")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.changeLayout
    },
    model: {
      value: (_vm.layoutForm.layoutType),
      callback: function($$v) {
        _vm.$set(_vm.layoutForm, "layoutType", $$v)
      },
      expression: "layoutForm.layoutType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "default",
      "value": "default"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "url",
      "value": "url"
    }
  }, [_vm._v("URL")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "dom",
      "value": "dom"
    }
  }, [_vm._v("DOM")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row fields-section"
  }, [(_vm.layoutForm.layoutType === 'dom') ? _c('div', {
    staticClass: "dom-section col-md-8"
  }, [_c('div', [_c('p', {
    staticClass: "form-label"
  }, [_vm._v("DOM Selector String")]), _vm._v(" "), _c('el-input', {
    staticClass: "publisher-input",
    attrs: {
      "name": "selector",
      "type": "text",
      "placeholder": "DOM Selector String",
      "required": ""
    },
    model: {
      value: (_vm.layoutForm.selectorData.domSelectorString),
      callback: function($$v) {
        _vm.$set(_vm.layoutForm.selectorData, "domSelectorString", $$v)
      },
      expression: "layoutForm.selectorData.domSelectorString"
    }
  })], 1), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "form-label"
  }, [_vm._v("DOM Node Attribute")]), _vm._v(" "), _c('el-input', {
    staticClass: "publisher-input",
    attrs: {
      "name": "selector",
      "type": "text",
      "placeholder": "DOM Node Attribute",
      "required": ""
    },
    model: {
      value: (_vm.layoutForm.selectorData.domNodeAttribute),
      callback: function($$v) {
        _vm.$set(_vm.layoutForm.selectorData, "domNodeAttribute", $$v)
      },
      expression: "layoutForm.selectorData.domNodeAttribute"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.layoutForm.layoutType !== 'default') ? _c('div', {
    staticClass: "target-section col-md-8"
  }, [_c('div', [_c('p', {
    staticClass: "form-label"
  }, [_vm._v("Operator")]), _vm._v(" "), _c('el-select', {
    staticClass: "publisher-input select-input",
    attrs: {
      "collapse-tags": "",
      "filterable": "",
      "placeholder": "Select",
      "required": ""
    },
    model: {
      value: (_vm.layoutForm.selectorData.operator),
      callback: function($$v) {
        _vm.$set(_vm.layoutForm.selectorData, "operator", $$v)
      },
      expression: "layoutForm.selectorData.operator"
    }
  }, _vm._l((['equals', 'contains']), function(option, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": option,
        "value": option
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "form-label"
  }, [_vm._v("Value")]), _vm._v(" "), _c('el-input', {
    staticClass: "publisher-input",
    attrs: {
      "name": "selector",
      "type": "text",
      "placeholder": "Match String",
      "required": ""
    },
    model: {
      value: (_vm.layoutForm.selectorData.data),
      callback: function($$v) {
        _vm.$set(_vm.layoutForm.selectorData, "data", $$v)
      },
      expression: "layoutForm.selectorData.data"
    }
  })], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', [_vm._v("Active")]), _vm._v(" "), _c('div', {
    staticClass: "m-t-5"
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.layoutForm.isActive),
      callback: function($$v) {
        _vm.$set(_vm.layoutForm, "isActive", $$v)
      },
      expression: "layoutForm.isActive"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 save-section"
  }, [_c('button', {
    staticClass: "el-button el-button--secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm()
      }
    }
  }, [_vm._v("\n                                Reset\n                            ")]), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])])]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 50, 100],
      "total": _vm.total_Pages,
      "layout": "sizes, prev, pager, next",
      "page-size": _vm.offset
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2982c61b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/first-impression/Layout.vue
// module id = 668
// module chunks = 2